import React from "react";
export function isLocationWithinRadius(lat1, lon1, lat2, lon2, radiusInMeters) {
  // Radius of the Earth in meters
  const earthRadius = 6371000;
  // Convert latitude and longitude from degrees to radians
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);

  // Calculate the distance using the Haversine formula
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Calculate the distance in meters
  const distance = earthRadius * c;

  // Check if the distance is within the specified radius
  return distance <= radiusInMeters;
}

const BROWSER_TO_APP_LANGUAGE = {
  en: "en",
  el: "el",
  de: "de",
  ru: "ru",
  uk: "ua",
  ua: "ua",
  sr: "se",
  se: "se",
};

export function findPreferredLanguage() {
  const preferredLanguages = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  for (const language of preferredLanguages) {
    const baseLanguage = String(language || "").toLowerCase().split("-")[0];
    const matchedLanguage = BROWSER_TO_APP_LANGUAGE[baseLanguage];

    if (matchedLanguage) {
      return matchedLanguage;
    }
  }

  return "en";
}

export function getLongLanguageName(shortCode) {
  const languageMap = {
    en: "English",
    de: "Deutsch",
    ru: "Russian",
    el: "Ελληνικά",
    se: "Serbian",
    ua: "Ukrainian",
  };
  return languageMap[shortCode] || shortCode;
}

export function calculateDistance(coord1, coord2) {
  const { latitude: lat1, longitude: lon1 } = coord1;
  const { latitude: lat2, longitude: lon2 } = coord2;

  // Radius of the Earth in meters
  const R = 6371000;

  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c; // Distance in meters

  return distance;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function useTimer({ expirationSeconds, onExpire }) {
  const [secondsLeft, setSecondsLeft] = React.useState(expirationSeconds);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(secondsLeft - 1);
      if (secondsLeft === 0) {
        onExpire();
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsLeft, onExpire]);

  return secondsLeft;
}

export async function getConnectedSSID() {
  try {
    // Try frontend API
    //   const conn =
    //     navigator.connection ||
    //     navigator.mozConnection ||
    //     navigator.webkitConnection;
    //   if (conn.ssid) return conn.ssid;

    // Fallback to getting from backend
    const res = await fetch(`/api/get-ssid`);
    console.log("res is :", res);
    const data = await res.json();
    console.log("data is ", data);
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const handleButtonSpecificLogic = (
  setButtonActive,
  setCountdown,
  countTimer,
  button
) => {
  const b = button === "Bill" ? "ButtonBill" : "WaiterButton";
  // Update button state
  setButtonActive(false);

  // Store start time in localStorage
  const startTime = Math.floor(new Date().getTime() / 1000);
  localStorage.setItem(`StartTime${button}`, startTime.toString());
  setCountdown(countTimer);
  localStorage.setItem(`is${b}Active`, JSON.stringify(false));
};

export const getRestCoords = (contacts) => {
  const { restSpot, ...rest } = contacts.coords;
  return [restSpot, rest];
};

export function getUmbrellaMessage  ( zont ) {
  const umbrellaMapForMessages = {
    1: "1А",
    2: "1В",
    3: "1Г",
    4: "1Δ",
    5: "1Е",
    6: "2А",
    7: "2В",
    8: "2Г",
    9: "2Δ",
    10: "2Е",
    11: "3А",
    12: "3В",
    13: "3Г",
    14: "3Δ",
    15: "3Е",
    16: "4А",
    17: "4В",
    18: "4Г",
    19: "4Δ",
    20: "4Е",
    21: "5А",
    22: "5В",
    23: "5Г",
    24: "5Δ",
    25: "5Е",
    26: "6А",
    27: "6В",
    28: "6Г",
    29: "6Δ",
    30: "6Е",
    31: "7А",
    32: "7В",
    33: "7Г",
    34: "7Δ",
    35: "7Е",
    36: "8А",
    37: "8В",
    38: "8Г",
    39: "8Δ",
    40: "8Е",
    41: "9А",
    42: "9В",
    43: "9Г",
    44: "9Δ",
    45: "9Е",
    46: "10А",
    47: "10В",
    48: "10Г",
    49: "10Δ",
    50: "10Е"
  };
    return umbrellaMapForMessages[zont] || zont;
  };
